export default "__VITE_ASSET__cl_Tv4m8__"